import {reactive, computed, toRefs} from "vue"
import type {ToRefs, ComputedRef} from "vue"
//@ts-ignore
import {useCommonVars} from "@wkComposables/useCommonVars"
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";
interface SelectOptionsFranchise {
    id: number,
    label: string,
    uri: string
}

interface UsableAgencyFiltersState {
    agencyFilter: {
        name: Nullable<string>;
        franchiseId: Nullable<number>;
        uri: string;
        idName: string;
    };
    currentSearchFranchiseIdName: string;
    isPlacePresent: string;
}

interface UsableAgencyFilters extends ToRefs<UsableAgencyFiltersState>{
    currentSearchName: ComputedRef<Nullable<string>>;
    franchiseList: ComputedRef<SelectOptionsFranchise[]>;
    currentSearchFranchiseOptions: ComputedRef<Nullable<SelectOptionsFranchise>>;
    cdn: ComputedRef<string>;
    labels: ComputedRef<Record<string, string>>;
    getOptions: (key: string) => SelectOptionsFranchise[];
}

export function useAgencyFilters(): UsableAgencyFilters{
    const state = reactive<UsableAgencyFiltersState>({
        agencyFilter: {
            name: "",
            franchiseId: null ,
            uri: "" ,
            idName: "",
        },
        currentSearchFranchiseIdName: "",
        isPlacePresent: "",
    })

    const currentSearchName = computed((): Nullable<string> => {
        return new URLSearchParams(window.location.search).get("Nome");
    })
    const franchiseList = computed((): SelectOptionsFranchise[] => {
        const tmpListFranchise = getOptions("franchiseList");
        if (state.isPlacePresent)
            return tmpListFranchise;

        // the option qualsiasi need to be hided if there is no place
        return tmpListFranchise.slice(1);
    })
    const currentSearchFranchiseOptions = computed((): Nullable<SelectOptionsFranchise> => {
        return franchiseList.value.find(franchise => franchise.label.toLowerCase() === state.currentSearchFranchiseIdName.toLowerCase()) ?? null;
    })

    const {cdn, wkLabels: labels} = useCommonVars()

    const getOptions = (key: string): SelectOptionsFranchise[] => {
        return window["_options"][key];
    }

    return {
        ...toRefs(state),
        currentSearchName,
        franchiseList,
        currentSearchFranchiseOptions,
        cdn,
        labels,
        getOptions
    }

}
